import styled from 'styled-components'
import DefaultWebcam from 'react-webcam'
import { Button as DefaultButton, Title as DefaultTitle } from '~components'
import ellipseSrc from '~assets/images/ellipse.png'

export const Wrapper = styled.div`
  display: flex;
  position: relative; 

  #box-camera { 
    width: 350px;
    height: 400px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    #box-camera { 
      width: 100%;
    }
  }
`

export const Title = styled(DefaultTitle)`
  margin-bottom: ${({ theme }) => theme.spacing.km8};
`


export const Webcam = styled(DefaultWebcam).attrs({ 'aria-label': 'camera' })`
  border-radius: ${({ theme }) => theme.border.radius.medium};

  @media (max-width: ${({ theme }) => theme.breakpoint.md.maxWidth}) {
    border-radius: 0;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

export const Overlay = styled.img.attrs({ src: ellipseSrc })`
  position: absolute;
  margin: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;

  @media (max-width: ${({ theme }) => theme.breakpoint.md.maxWidth}) {
    width: 75%;
    top: 35%;
  }
`

export const Button = styled(DefaultButton)`
  margin-top: ${({ theme }) => theme.spacing.km8};

  @media (max-width: ${({ theme }) => theme.breakpoint.md.maxWidth}) {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 3;
    margin: ${({ theme }) => theme.spacing.km8} ${({ theme }) => theme.spacing.km4};
    width: -webkit-fill-available;
  }
`

export const StandardCameraWrapper = styled.div`
  display: flex;
  position: relative;

  @media (max-width: ${({ theme }) => theme.breakpoint.md.maxWidth}) {
    border-radius: 0;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 2;
    background: black;
  }
`

